<ng-container
  [ngTemplateOutlet]="template"
  [ngTemplateOutletContext]="{
    isLoading: (isLoading$ | async),
    appCopyright: (appCopyright$ | async),
    isbottomNavigationtEnabled: (isbottomNavigationtEnabled$ | async),
    isCopyrightEnabled: (isCopyrightEnabled$ | async)
  }"
>
</ng-container>

<ng-template
  #template
  let-isLoading="isLoading"
  let-appCopyright="appCopyright"
  let-isbottomNavigationtEnabled="isbottomNavigationtEnabled"
  let-isCopyrightEnabled="isCopyrightEnabled"
>
  @if (isbottomNavigationtEnabled || appCopyright) {
    <mat-toolbar class="menu site-footer" flexLayout="row" flexLayoutAlign="space-between stretch">
      <div flex flexLayout="row" flexLayoutAlign="start stretch">
        @if (isCopyrightEnabled || appCopyright) {
          <ng-container>
            <vp-bottom-nav-copyright
              flexLayout="row"
              flexLayoutAlign="start center"
              [appCopyright]="appCopyright"
            ></vp-bottom-nav-copyright>
          </ng-container>
        }
      </div>
    </mat-toolbar>
  }

  @if (isLoading) {
    <div class="center">
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>
  }
</ng-template>
